import { Outlet } from 'react-router-dom';

import React from 'react';
import { Header } from '../organisms/Header';
import Footer from '../organisms/Footer';

export const SimpleLayout = () => {
    return (
        <div className="App flex flex-col min-h-screen">
            <Header />
            <div className="flex-grow">
                <Outlet />
            </div>
            <Footer />
        </div>

    );
};

